<template>
  <nav class="menu-container">
    <h3><font color="#DC241F">4号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          name: "futiankouan",
          title: "福田口岸",
          // icon: "chat",
          exact: true,
        },
        {
          name: "fumin",
          title: "福民",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huizhanzhongxin",
          title: "会展中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiminzhongxin",
          title: "市民中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shaoniangong",
          title: "少年宫",
          // icon: "chat",
          exact: true,
        },
        {
          name: "lianhuabei",
          title: "莲花北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shangmeilin",
          title: "上梅林",
          // icon: "chat",
          exact: true,
        },
        {
          name: "minle",
          title: "民乐",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baishilong",
          title: "白石龙",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shenzhenbei",
          title: "深圳北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "hongshan",
          title: "红山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shangtang",
          title: "上塘",
          // icon: "chat",
          exact: true,
        },
        {
          name: "longsheng",
          title: "龙胜",
          // icon: "chat",
          exact: true,
        },
        {
          name: "longhua",
          title: "龙华",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qinghu",
          title: "清湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "qinghubei",
          title: "清湖北",
          // icon: "chat",
          exact: true,
        },
        {
          name: "zhucun",
          title: "竹村",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xikeng",
          title: "茜坑",
          // icon: "chat",
          exact: true,
        },
        {
          name: "changhu",
          title: "长湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guanlan",
          title: "观澜",
          // icon: "chat",
          exact: true,
        },
        {
          name: "songyuanxia",
          title: "松元厦",
          // icon: "chat",
          exact: true,
        },
        {
          name: "guanlanhu",
          title: "观澜湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "niuhu",
          title: "牛湖",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>



